const listingClaimUtils = {
  getConversionRate: ({ failed, succeeded, total }: { [key: string]: number }) => ((failed + succeeded) / total) * 100,
};

export default listingClaimUtils;
